module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/axios/index.js
// module id = 49
// module chunks = 1